import React, { createContext, useState, useContext } from 'react';

const EnquiryContext = createContext();

export const useEnquiry = () => {
    const context = useContext(EnquiryContext);
    if (!context) {
        throw new Error('useEnquiry must be used within an EnquiryProvider');
    }
    return context;
};

export const EnquiryProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openEnquiry = () => setIsOpen(true);
    const closeEnquiry = () => setIsOpen(false);
    const toggleEnquiry = () => setIsOpen(prev => !prev);

    return (
        <EnquiryContext.Provider value={{ isOpen, openEnquiry, closeEnquiry, toggleEnquiry }}>
            {children}
        </EnquiryContext.Provider>
    );
};
